import { Skeleton } from '@/shared/ui/primitives';

export function ChatLoadingSkeleton() {
  return (
    <div className="mx-auto w-full max-w-2xl space-y-4 py-4" role="status" aria-label="Loading">
      <Skeleton className="ml-2 h-12 w-3/4 rounded-lg" />
      <Skeleton className="mr-2 ml-auto h-10 w-2/3 rounded-lg" />
      <Skeleton className="ml-2 h-14 w-4/5 rounded-lg" />
      <Skeleton className="mr-2 ml-auto h-10 w-1/2 rounded-lg" />
    </div>
  );
}
